import React from 'react';
import PropTypes from 'prop-types';
import { GoogleMap, Marker, withScriptjs, withGoogleMap } from 'react-google-maps';

import location from './images/location.svg';

const GMap = ({ position }) => (
  <GoogleMap
    defaultZoom={18}
    defaultCenter={position}
    defaultOptions={{
      disableDefaultUI: true
    }}
  >
    <Marker
      position={position}
      defaultIcon={location}
    />
  </GoogleMap>
);

GMap.propTypes = {
  position: PropTypes.shape({
    lat: PropTypes.number.isRequired,
    lng: PropTypes.number.isRequired
  }).isRequired
};


export default withScriptjs(withGoogleMap(GMap));



// WEBPACK FOOTER //
// ./src/pages/Delivery/components/PickUpModal/GMap.js